import { inject, Injectable } from '@angular/core';
import { APIConstants } from '../constants/api.constant';
import { CommonApiFuncService } from '@anddone/ui-utilities';
import { BehaviorSubject, catchError, tap } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  public userAddStatus = new BehaviorSubject(false);
  currentUserAddStatus = this.userAddStatus.asObservable();

  public userDetailUpdate = new BehaviorSubject(false);
  currentUserDetailUpdate = this.userDetailUpdate.asObservable();

  public updateRollAPIKey = new BehaviorSubject(false);
  updatedRollAPIKey = this.updateRollAPIKey.asObservable();

  private apiKeySubject = new BehaviorSubject<boolean>(false);
  private userDetailsSubject = new BehaviorSubject<boolean>(false);

  private commonAPIFuncService = inject(CommonApiFuncService);

  getUserDetailsById(reqObj: any) {
    const url = APIConstants.agentUser.getUserDetailsById
      .replace('{allyId}', reqObj.allyId)
      .replace('{userId}', reqObj.userId);
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.get(url, options).pipe(
      tap((_) => this.commonAPIFuncService.log(`getUserDetailsById success`)),
      catchError(this.commonAPIFuncService.handleError('getUserDetailsById error/failed'))
    );
  }

  getAllyUsers(allyId: any, reqObj?: any) {
    let url = APIConstants.user.users.replace('{allyId}', allyId);
    url = `${url}${this.commonAPIFuncService.buildQuery(reqObj)}`;
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.get(url, options).pipe(
      tap((_a) => this.commonAPIFuncService.log(`getAllyUsers success`)),
      catchError(this.commonAPIFuncService.handleError('getAllyUsers error/failed'))
    );
  }

  getKeys(reqObj: any) {
    const url = APIConstants.user.getAPIKeys
      .replace('{allyId}', reqObj.allyId)
      .replace('{userId}', reqObj.userId);
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.get(url, options).pipe(
      tap((_) => this.commonAPIFuncService.log(`getKeys success`)),
      catchError(this.commonAPIFuncService.handleError('getKeys error/failed'))
    );
  }

  activateUser(allyId: string, userId: string) {
    const url = APIConstants.user.activateUser
      .replace('{allyId}', allyId)
      .replace('{userId}', userId);
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.post(url, {}, options).pipe(
      tap((_a) => this.commonAPIFuncService.log(`activateUser success`)),
      catchError(this.commonAPIFuncService.handleError('activateUser error/failed'))
    );
  }

  deactivateUser(allyId: string, userId: string) {
    const url = APIConstants.user.deactivateUser
      .replace('{allyId}', allyId)
      .replace('{userId}', userId);
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.delete(url, options).pipe(
      tap((_a) => this.commonAPIFuncService.log(`deactivateUser success`)),
      catchError(this.commonAPIFuncService.handleError('deactivateUser error/failed'))
    );
  }

  addUser(reqObj: any, allyId: string) {
    const url = APIConstants.user.addUser.replace('{allyId}', allyId);
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.post(url, reqObj, options).pipe(
      tap((_a) => this.commonAPIFuncService.log(`addUser Success`)),
      catchError(this.commonAPIFuncService.handleError('addUser error/failed'))
    );
  }

  rollApiKey(obj: any, userId: string, allyId: string) {
    const url = APIConstants.user.rollAPIKeys
      .replace('{allyId}', allyId)
      .replace('{userId}', userId);
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.post(url, obj, options).pipe(
      tap((_a) => this.commonAPIFuncService.log(`rollApiKey success`)),
      catchError(this.commonAPIFuncService.handleError('rollApiKey error/failed'))
    );
  }

  editUser(reqObj: any, userId: string, allyId: string) {
    const url = APIConstants.user.editUser.replace('{allyId}', allyId).replace('{userId}', userId);
    const options = {
      customBaseUrl: environment.infraBaseUrl,
    };
    return this.commonAPIFuncService.put(url, reqObj, options).pipe(
      tap((_a) => this.commonAPIFuncService.log(`editUser Success`)),
      catchError(this.commonAPIFuncService.handleError('editUser error/failed'))
    );
  }

  updateAddUserStatus(status: boolean) {
    this.userAddStatus.next(status);
  }

  updateRollAPIKeyValue(status: boolean) {
    this.updateRollAPIKey.next(status);
  }

  updateUserDetails(status: boolean) {
    this.userDetailUpdate.next(status);
  }

  // Getter for the key property
  getAPIKey() {
    return this.apiKeySubject.asObservable(); // Expose as observable
  }

  // Setter for the key property
  setAPIKey(value: any) {
    this.apiKeySubject.next(value); // Update the loader state
  }

  // Getter for the key property
  getUserDetails() {
    return this.userDetailsSubject.asObservable(); // Expose as observable
  }

  // Setter for the key property
  setUserDetails(value: any) {
    this.userDetailsSubject.next(value); // Update the loader state
  }
}
